// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1lK6_","alert":"SettungsInbox_alert__ZmGGe"};